import { useMemo } from 'react';

import type { PinData } from '../../Map.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Hook to determine the currently active pin based on activePinId.
 * This hook is shared between native and web implementations.
 */
export const useActivePin = (params: Params) => {
  const { activePinId, customerPositionPin, filteredPins } = params;

  return useMemo(() => {
    if (activePinId === customerPositionPin?.id) {
      return customerPositionPin;
    }

    return filteredPins.find((pin) => pin.id === activePinId);
  }, [filteredPins, customerPositionPin, activePinId]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  activePinId?: string;
  customerPositionPin?: Omit<PinData, 'isCustomer'> & { isCustomer: true };
  filteredPins: PinData[];
};
